'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Label;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./label.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Label Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */
function Label(props) {
    var _cx;

    var _props$style = props.style,
        style = _props$style === undefined ? '' : _props$style,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$isBadge = props.isBadge,
        isBadge = _props$isBadge === undefined ? false : _props$isBadge,
        _props$isHollowBadge = props.isHollowBadge,
        isHollowBadge = _props$isHollowBadge === undefined ? false : _props$isHollowBadge,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    var classNames = (0, _classnames2.default)((_cx = {
        'sb-label': true,
        'sb-label--badge': isBadge,
        'sb-label--badge-hollow': isHollowBadge
    }, (0, _defineProperty3.default)(_cx, 'sb-label--' + style, style), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    return (0, _jsx3.default)('span', {
        className: classNames,
        id: id
    }, void 0, props.children);
}
// css
//# sourceMappingURL=Label.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/label/Label.js
// module id = 564
// module chunks = 0